import { createDomain, sample } from 'effector'
import { AxiosErrorType, Driver } from '~/shared/api'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { getDriver } from '../../model'
import { driverUploadDocumentsModel } from '../UploadDocumentsDrawer'

const domain = createDomain('entities.driver.retryChecks')

export const openRetryChecksDrawer = domain.createEvent()
export const closeRetryChecksDrawer = domain.createEvent()

export const $isRetryChecksDrawerOpen = domain
  .createStore<boolean>(false)
  .on(openRetryChecksDrawer, () => true)
  .on(closeRetryChecksDrawer, () => false)

export const retryChecks = domain.createEvent()
export const retryChecksFx = domain.createEffect<
  void,
  void,
  AxiosErrorType<{ documentsUploadRequired: boolean }>
>({
  handler: async () => {
    await Driver.retryChecks()
  },
})

sample({
  clock: retryChecks,
  target: retryChecksFx,
})

sample({
  clock: retryChecksFx.doneData,
  fn: () => {
    return {
      message:
        'Повтор проверок запрошен, ваш статус обновится через несколько минут',
      variant: 'success' as const,
    }
  },
  target: [snackbarEnqueued, getDriver, closeRetryChecksDrawer],
})

sample({
  clock: retryChecksFx.failData,
  filter: (e) => !e?.response?.data.documentsUploadRequired,
  fn: (e) => ({
    message: mapMessageErrors(e),
    variant: 'danger' as const,
  }),
  target: snackbarEnqueued,
})

sample({
  clock: retryChecksFx.failData,
  filter: (e) => Boolean(e?.response?.data.documentsUploadRequired),
  target: [
    closeRetryChecksDrawer,
    driverUploadDocumentsModel.openUploadDocumentDrawer,
  ],
})
